import React from 'react'
import styled from 'styled-components'
import { PostViewHeader } from './PostViewHeader'
import { PostViewSubHeader } from './PostViewSubHeader'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { TableOfContents } from './TableOfContents'

const Wrapper = styled.article`
  margin-bottom: var(--spacing-8);
  max-width: 800px;
`

const FeaturedImage = styled(GatsbyImage)`
  margin-bottom: var(--spacing-6);
`

export const PostView = ({
  author,
  featuredImage,
  title,
  tags,
  date,
  content,
  tableOfContents,
}) => {
  return (
    <Wrapper as="article" itemScope itemType="http://schema.org/Article">
      <PostViewHeader
        title={title}
        tags={tags}
        subheader={<PostViewSubHeader author={author} date={date} />}
      />
      {featuredImage && (
        <FeaturedImage image={getImage(featuredImage)} alt={title} />
      )}
      {tableOfContents && tableOfContents.length > 0 && (
        <TableOfContents html={tableOfContents} />
      )}
      <section
        dangerouslySetInnerHTML={{ __html: content }}
        itemProp="articleBody"
      />
    </Wrapper>
  )
}
